import {
  TDocument,
  TDocumentStatus,
  TDocumentType,
} from 'src/apis/documents/documents.interfaces';
import { mockUserAction } from '../users/userAction';
import { mockDocument } from '../documents/documentMock';

// Use diverse names - rotate through different Indian names
const indianNames = [
  'Rajesh Mehta', 'Sunita Joshi', 'Karan Desai', 'Neha Rao', 'Suresh Nair',
  'Shreya Agarwal', 'Manoj Sharma', 'Divya Patel', 'Deepak Kumar', 'Pooja Singh',
];
const getIndianName = (index: number) => indianNames[index % indianNames.length];

export const mockProfileDocuments: TDocument[] = [
  {
    ...mockDocument,
    documentId: 'doc123',
    userId: '123456789',
    documentType: TDocumentType.BIRTH_CERTIFICATE,
    documentName: `Birth Certificate - ${getIndianName(0)}`,
    submissionDate: '2023-10-18',
    verificationDate: '2023-10-20',
    status: TDocumentStatus.VERIFIED,
    remarks: 'Document verified successfully',
    uploadedAt: mockUserAction,
  },
  {
    ...mockDocument,
    documentId: 'doc456',
    userId: '123456789',
    documentType: TDocumentType.TRANSFER_CERTIFICATE,
    documentName: `Transfer Certificate - ${getIndianName(1)}`,
    submissionDate: '2023-10-18',
    verificationDate: '2023-10-21',
    status: TDocumentStatus.VERIFIED,
    remarks: 'Transfer certificate verified',
    uploadedAt: mockUserAction,
  },
  {
    ...mockDocument,
    documentId: 'doc789',
    userId: '123456789',
    documentType: TDocumentType.AADHAR_CARD,
    documentName: `Aadhar Card - ${getIndianName(2)}`,
    submissionDate: '2023-10-18',
    verificationDate: '2023-10-22',
    status: TDocumentStatus.VERIFIED,
    remarks: 'Aadhar card verified',
    uploadedAt: mockUserAction,
  },
  {
    ...mockDocument,
    documentId: 'doc171',
    userId: '123456789',
    documentType: TDocumentType.PAN_CARD,
    documentName: `PAN Card - ${getIndianName(3)}`,
    submissionDate: '2023-10-18',
    verificationDate: '2023-10-23',
    status: TDocumentStatus.VERIFIED,
    remarks: 'PAN card verified',
    uploadedAt: mockUserAction,
  },
  {
    ...mockDocument,
    documentId: 'doc162',
    userId: '123456789',
    documentType: TDocumentType.SALARY_SLIP,
    documentName: `Salary Slip - July 2023 - ${getIndianName(4)}`,
    submissionDate: '2023-07-18',
    verificationDate: '2023-07-20',
    status: TDocumentStatus.VERIFIED,
    remarks: 'Salary slip verified',
    uploadedAt: mockUserAction,
  },
  {
    ...mockDocument,
    documentId: 'doc152',
    userId: '123456789',
    documentType: TDocumentType.SALARY_SLIP,
    documentName: `Salary Slip - August 2023 - ${getIndianName(5)}`,
    submissionDate: '2023-08-18',
    status: TDocumentStatus.PENDING,
    uploadedAt: mockUserAction,
  },
  {
    ...mockDocument,
    documentId: 'doc142',
    userId: '123456789',
    documentType: TDocumentType.SALARY_SLIP,
    documentName: `Salary Slip - September 2023 - ${getIndianName(6)}`,
    submissionDate: '2023-09-18',
    status: TDocumentStatus.PENDING,
    uploadedAt: mockUserAction,
  },
  {
    ...mockDocument,
    documentId: 'doc132',
    userId: '123456789',
    documentType: TDocumentType.SALARY_SLIP,
    documentName: `Salary Slip - October 2023 - ${getIndianName(7)}`,
    submissionDate: '2023-10-18',
    status: TDocumentStatus.PENDING,
    uploadedAt: mockUserAction,
  },
  {
    ...mockDocument,
    documentId: 'doc122',
    userId: '123456789',
    documentType: TDocumentType.SALARY_SLIP,
    documentName: `Salary Slip - November 2023 - ${getIndianName(8)}`,
    submissionDate: '2023-11-18',
    status: TDocumentStatus.PENDING,
    uploadedAt: mockUserAction,
  },
  {
    ...mockDocument,
    documentId: 'doc112',
    userId: '123456789',
    documentType: TDocumentType.SALARY_SLIP,
    documentName: `Salary Slip - December 2023 - ${getIndianName(9)}`,
    submissionDate: '2023-12-18',
    status: TDocumentStatus.PENDING,
    uploadedAt: mockUserAction,
  },
  {
    ...mockDocument,
    documentId: 'doc103',
    userId: '123456789',
    documentType: TDocumentType.JOINING_LETTER,
    documentName: `Joining Letter - ${getIndianName(0)}`,
    submissionDate: '2023-06-18',
    verificationDate: '2023-06-20',
    status: TDocumentStatus.VERIFIED,
    remarks: 'Joining letter verified',
    uploadedAt: mockUserAction,
  },
  {
    ...mockDocument,
    documentId: 'doc104',
    userId: '123456789',
    documentType: TDocumentType.PROMOTION_LETTER,
    documentName: `Promotion Letter - ${getIndianName(1)}`,
    submissionDate: '2023-05-18',
    verificationDate: '2023-05-20',
    status: TDocumentStatus.VERIFIED,
    remarks: 'Promotion letter verified',
    uploadedAt: mockUserAction,
  },
  {
    ...mockDocument,
    documentId: 'doc105',
    userId: '123456789',
    documentType: TDocumentType.LEAVE_LETTER,
    documentName: `Leave Letter - ${getIndianName(2)}`,
    submissionDate: '2023-04-18',
    verificationDate: '2023-04-20',
    status: TDocumentStatus.APPROVED,
    remarks: 'Leave letter approved',
    uploadedAt: mockUserAction,
  },
  {
    ...mockDocument,
    documentId: 'doc106',
    userId: '123456789',
    documentType: TDocumentType.OTHER,
    documentName: `Other Document - ${getIndianName(3)}`,
    submissionDate: '2023-03-18',
    status: TDocumentStatus.PENDING,
    uploadedAt: mockUserAction,
  },
];
